import * as React from "react";
import { cn } from "./utils";

function ReportCard({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "bg-white text-slate-900 flex flex-col rounded-xl border border-[#e8e3dc] shadow-sm",
        className,
      )}
      {...props}
    />
  );
}

export { ReportCard };
